import React from 'react';
import { useNavigate } from 'react-router-dom';
import CustomBeforeAfterSlider from '../components/CustomBeforeAfterSlider';
import './Page2.css';

import bg_gotas_big from './../assets/page2/page2_soy_before.png';
import bg_gotas_small from './../assets/page2/page2_soy_after.png';
import homeButtonImage from './../assets/commum/button_home.png';

function Page2_1() {
  const navigate = useNavigate();

  return (
    <div className="page2-container">
      <CustomBeforeAfterSlider firstImage={bg_gotas_big} secondImage={bg_gotas_small} />
      <div className="back-button" style={{ bottom: '119px', left: '75px', width: '76px', height: '50px' }} onClick={() => navigate('/page2')}>
        <img src={homeButtonImage} alt="Home Button" />
      </div>
    </div>
  );
}

export default Page2_1;
